import { render, staticRenderFns } from "./ChatSession.vue?vue&type=template&id=0f616ef0"
import script from "./ChatSession.vue?vue&type=script&lang=js"
export * from "./ChatSession.vue?vue&type=script&lang=js"
import style0 from "./ChatSession.vue?vue&type=style&index=0&id=0f616ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports